import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation DeleteAssetTypeMaintenanceSchedule($companyId: ID!, $id: ID!) {
    deleteAssetTypeMaintenanceSchedule(companyId: $companyId, id: $id) {
      assetTypeMaintenanceSchedule {
        id
      }
      errors {
        path
        message
      }
    }
  }
`
